export const mediaQueryXSmall = '@media (max-width: 576px)';
export const mediaQuerySmall = '@media (max-width: 768px)';
export const mediaQueryMedium = '@media (max-width: 992px)';
export const mediaQueryLarge = '@media (max-width: 1200px)';

export const media = {
  xSmall: mediaQueryXSmall,
  small: mediaQuerySmall,
  medium: mediaQueryMedium,
  large: mediaQueryLarge,
};

export const maxes = {
  width: '1280px',
};
